import { render, staticRenderFns } from "./ProblemsPanel.vue?vue&type=template&id=90f2e25a&"
import script from "./ProblemsPanel.vue?vue&type=script&lang=js&"
export * from "./ProblemsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports